module.exports = __webpack_public_path__ + "img/Pierce-2.8ba645f7.png";